import { useEffect, useState } from 'react';
import { BREAKPOINTS } from './config';
var supportsWindow = typeof window !== 'undefined' && window.matchMedia !== undefined;
var breakpointValues = Object.values(BREAKPOINTS);
var getInitialBreakpoint = () => {
  if (supportsWindow) {
    for (var [key, query] of Object.entries(queries)) {
      if (window.matchMedia(query).matches) {
        return key;
      }
    }
  }
  return 'base';
};
var queries = Object.fromEntries(Object.keys(BREAKPOINTS).map((key, index) => {
  var isLastBreakpoint = index === breakpointValues.length - 1;
  var minQuery = "(min-width: ".concat(breakpointValues[index], "px)");
  var maxQuery = "(max-width: ".concat(breakpointValues[index + 1] - 1, "px)");
  return [key, isLastBreakpoint ? minQuery : "".concat(minQuery, " and ").concat(maxQuery)];
}));
export var useBreakpoint = () => {
  var [value, setValue] = useState(() => getInitialBreakpoint());
  useEffect(() => {
    if (!supportsWindow) {
      return;
    }
    var handlers = Object.keys(queries).map(key => {
      return _ref => {
        var {
          matches
        } = _ref;
        return matches && setValue(key);
      };
    });
    Object.values(queries).forEach((query, index) => {
      var mediaQuery = window.matchMedia(query);
      if (mediaQuery !== null && mediaQuery !== void 0 && mediaQuery.addEventListener) {
        mediaQuery.addEventListener('change', handlers[index]);
      } else {
        mediaQuery.addListener(handlers[index]);
      }
    });
    return () => {
      Object.values(queries).forEach((query, index) => {
        var mediaQuery = window.matchMedia(query);
        if (mediaQuery !== null && mediaQuery !== void 0 && mediaQuery.removeEventListener) {
          mediaQuery.removeEventListener('change', handlers[index]);
        } else {
          mediaQuery.removeListener(handlers[index]);
        }
      });
    };
  }, []);
  return value;
};
//# sourceMappingURL=useBreakpoint.js.map